import { assetsFormatter } from 'formatters'
import { Typography } from '@mui/material'

const ASLGeneralReportGridFrooter = (_props) => {
/*     {
      "acreditation": 1120,
      "liquidation": 170.75,
      "total": 949.25
  } */
  const { acreditation = 0, liquidation = 0, total = 0 } = _props
  return (
    <div className="flex flex-row w-full justify-start items-center bg-gray1 py-grid rounded-md mt-[6px]">
      <Typography
        variant="h4"
        component="div"
        className="flex flex-row flex-shrink-0 min-w-[130px] px-grid"
      >
        <strong>
          Total
        </strong>
      </Typography>
      <Typography
        variant="h4"
        component="div"
        className="flex flex-row flex-shrink-0 flex-grow min-w-[100px] px-grid"
      >
        <strong>{acreditation}</strong>
      </Typography>
      <Typography
        variant="h4"
        component="div"
        className="flex flex-row flex-shrink-0 flex-grow min-w-[100px] px-grid"
      >
        <strong>{liquidation}</strong>
      </Typography>
      <Typography
        variant="h4"
        component="div"
        className="flex flex-row flex-shrink-0 flex-grow min-w-[100px] px-grid"
      >
        <strong>{total}</strong>
      </Typography>
    </div>
  )
}

export default ASLGeneralReportGridFrooter
